import { Component, Input } from '@angular/core'
import { CostInvoiceRead } from '@app/generated'
import { FormControl, Validators } from '@angular/forms'
import { LoaderService } from '@core/services/loader.service'
import { Router } from '@angular/router'
import { config } from '@config'
import { ModalService } from '@core/services/modal.service'
import { DocumentTypeEnum } from '@app/generated/model/documentTypeEnum'

@Component({
	selector: 'app-create-based-on-the-cost',
	templateUrl: './create-based-on-the-cost.component.html',
	styleUrl: './create-based-on-the-cost.component.scss',
})
export class CreateBasedOnTheCostComponent {
	@Input() costInvoices: CostInvoiceRead[] = []
	@Input() orderId?: string
	@Input() taskId?: string
	@Input() entityId?: string
	@Input() containerNumber?: string | null

	readonly documentTypes = [
		{ text: $localize`Consolidated invoice`, value: DocumentTypeEnum.ConsolidatedInvoice },
		{ text: $localize`Split invoice`, value: DocumentTypeEnum.SplitInvoice },
	]
	formControl: FormControl = new FormControl<DocumentTypeEnum | null>(DocumentTypeEnum.SplitInvoice, [
		Validators.required,
	])
	protected readonly textDocumentType = $localize`Document type`
	protected readonly textConfirm = $localize`Confirm`

	constructor(
		private loaderService: LoaderService,
		private modalService: ModalService,
		private router: Router,
	) {}

	async confirm(): Promise<void> {
		const path: string =
			this.formControl.value == DocumentTypeEnum.SplitInvoice ? 'split-invoice' : 'consolidated-invoice'

		this.loaderService.setContain().enable(async () => {
			await this.router.navigate([`/${config.modules.invoices.path}/create/${path}`], {
				queryParams: {
					c: this.costInvoices.map(elem => elem.id).join(','),
					...(this.orderId ? { o: this.orderId } : {}),
					...(this.taskId ? { t: this.taskId } : {}),
					...(this.entityId ? { e: this.entityId } : {}),
					...(this.containerNumber ? { cn: this.containerNumber ?? undefined } : {}),
				},
			})
			this.modalService.close()
		})
	}
}
